export enum GenderEnum {
  male = 'masculino',
  female = 'feminino',
  other = 'outro'
}
